import { render, staticRenderFns } from "./ListUserAssessment.vue?vue&type=template&id=1655ad1f&"
import script from "./ListUserAssessment.vue?vue&type=script&lang=js&"
export * from "./ListUserAssessment.vue?vue&type=script&lang=js&"
import style0 from "./ListUserAssessment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports